import * as actionTypes from "../ActionTypes";
import API from "../../network/redAPI";
import { checkAuthError, logoutuser, dates, allslots } from "../../helper/constant";
let user = localStorage.getItem("user");

const expressMode = localStorage.getItem('expressMode') || 0;

export const getPaymentMethod = (dispatch) => {
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  API.GetPaymentMethod()
  .then((response) => {
    if(checkAuthError(response)){
    //logout 
    throw new Error("Unauthorized")
    }
    else{
      return response.json() 
    }
  })
    .then(async (data) => {
      dispatch({
        type: actionTypes.Loading_Disable,
      });
      if (data.success) {
        dispatch({
          type: actionTypes.Get_PaymentMethod,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      dispatch({
        type: actionTypes.Loading_Disable,
      });
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
}

export const deletePaymentMethod = (id, dispatch) => {
  API.DeletePaymentMethod(id)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Delete_PaymentMethod,
          success: data.success,
        });
        getPaymentMethod(dispatch);
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const getAddress = async (dispatch) => {
  let parsedUser = JSON.parse(user);
  let cust_id = parsedUser.cust_id;
  let body = { cust_id };

  dispatch({
    type: actionTypes.Loading_Enable,
  });
  return await API.GetAddress(body, expressMode)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      dispatch({
        type: actionTypes.Loading_Disable,
      });
      if (data.success) {
        dispatch({
          type: actionTypes.Get_Address,
          payload: data.data,
          success: data.success,
        });
        return data.data
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      dispatch({
        type: actionTypes.Loading_Disable,
      });
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const addAddress = async (body, dispatch) => {
  await API.AddAddress(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Add_Address,
          payload: data.data,
          success: data.success,
        });
        await getAddress(dispatch);
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const updateAddress = (body, dispatch) => {
  API.UpdateAddress(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Update_Address,
          payload: data.data,
          success: data.success,
        });
        await getAddress(dispatch);
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};
export const deleteAddress = (body, dispatch) => {
  API.DeleteAddress(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Delete_Address,
          payload: data.data,
          success: data.success,
        });
        getAddress(dispatch);
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const updateProfile = (body, dispatch) => {
  API.UpdateProfile(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        await localStorage.setItem("user", JSON.stringify(data.data));

        let parsedUser = JSON.parse(localStorage.getItem("user"));
        let {
          cust_id,
          first_name,
          last_name,
          phone,
          email,
          gender,
          createdAt,
        } = parsedUser;
        // window.analytics && window.analytics.track("Profile updated by " + email, {
        //   cust_id,
        //   first_name,
        //   gender,
        //   email,
        //   phone,
        //   joined_on: createdAt,
        // });

        dispatch({
          type: actionTypes.Update_Profile,
          payload: data.data,
          success: data.success,
        });
        window.location.reload();
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};
export const currentOrders = (body, dispatch) => {
  API.CurrentOrders(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Current_Orders,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};
export const pastOrders = (body, dispatch) => {
  API.PastOrders(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Past_Orders,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      // alert("Your login session is invalid, please login again");
      // logoutuser();
    });
};
export const fetchParticularOrder = (body, dispatch) => {
	// Use V2 endpoint with enhanced item display
  API.FetchParticularOrder(body)
    .then((response) => {
      if(checkAuthError(response)){
	      //logout
      throw new Error("Unauthorized")
      }
      else{
	      return response.json()
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Fetch_Particular_Order,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};
export const alldeliverySlots = async (body, dispatch) => {
	try {
		const response = await API.getAllSlotsDelivery(body);

		if (checkAuthError(response)) {
			alert("Your login session is invalid, please login again");
			logoutuser();
			return; // Stop execution if unauthorized
		}

		const data = await response.json();

		if (data.success && data.data) {
			dispatch({
				type: actionTypes.Delivery_Slots,
				payload: data.data,
				success: data.success,
			});
		} else {
			// Handle cases where API returns success: false but no auth error
			console.warn("API reported success: false for delivery slots:", data);
			// Optionally, you might dispatch an error action here if needed
		}
	} catch (err) {
		console.error("Failed to fetch delivery slots:", err);
		// Optionally, you might dispatch an error action here if needed
	}
};

export const slotsForDate = (body, dispatch) => {
  API.AllSlotsForDate(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Delivery_Slots_By_Date,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error)
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};
export const allCouponCodes = (body, dispatch) => {
  API.GetAllCouponCodes(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      if (data.success) {
        if (body["search"] != "") {
          data.data.sort((a, b) => {
            if (
              a.code.indexOf(body["search"]) > b.code.indexOf(body["search"])
            ) {
              return 1;
            } else if (
              a.code.indexOf(body["search"]) < b.code.indexOf(body["search"])
            ) {
              return -1;
            } else {
              if (a.code > b.code) return 1;
              else return -1;
            }
          });
        }
        dispatch({
          type: actionTypes.Get_All_Coupons,
          payload:
            body["search"] != ""
              ? data.data.sort((a, b) => {
                  return (
                    a.code.indexOf(body["search"]) -
                    b.name.indexOf(body["search"])
                  );
                })
              : data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const moveToCheckout = (body, dispatch) => {
  API.MoveToCheckout(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then((data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Move_To_Checkout,
          payload: [data.data],
          success: data.success,
        });
      } else {
        console.log(data.error);
      }
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const makePayment = (body, dispatch) => {
  API.OpenPaymentDialog(body)
    .then((response) => {
      if(checkAuthError(response)){
      //logout 
      throw new Error("Unauthorized")
      }
      else{
        return response.json() 
      }
    })
    .then(async (data) => {
      console.log("Payment Response ", data.data);
      dispatch({
        type: actionTypes.Pay_By_Card,
        payload: data.data,
        success: data.success,
      });
    })
    .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
    });
};

export const reOrder = (body, dispatch) => {
  API.Reorder(body)
      .then((response) => {
        if(checkAuthError(response)){
        //logout 
        throw new Error("Unauthorized")
        }
        else{
          return response.json() 
        }
      })
     .then(async (data) => {
        console.log("response for reorder ", data);
        if(data.success){
          localStorage.setItem("order_id",data.data);
          dispatch({
            type: actionTypes.Reorder,
            reordersuccess: data.success
          });
          document.getElementById("root").classList.remove("loading");
        }
        else{
          document.getElementById("root").classList.remove("loading");
          alert(data.message);
        }
     })
     .catch(err => {
      if (err.message === "Unauthorized"){
        alert("Your login session is invalid, please login again");
        logoutuser();
      }
     });
};

export const resetreordersuccess = (dispatch) => {
  dispatch({
    type: actionTypes.Reset_Reorder_Success
  });
};

export const searchAddressSuggestions = async (body) => {
    try {
        const response = await API.addressSuggestion(body);

        if (checkAuthError(response)) {
            // If authorization error, throw an error
            throw new Error("Unauthorized");
        }

        const data = await response.json();
        console.log("address ", data);  // Do something with the data here

        // Return the data (or transform it as needed)
        return data;

    } catch (err) {
        if (err.message === "Unauthorized") {
            alert("Your login session is invalid, please login again");
            logoutuser();  // Handle logout if the session is invalid
        } else {
            console.error("Error fetching address suggestions:", err);
        }

        // Return null or an empty array in case of an error
        return null;
    }
};

export const addressDetail = async (body) => {
    try {
        const response = await API.addressGeoCod(body);

        if (checkAuthError(response)) {
            // If authorization error, throw an error
            throw new Error("Unauthorized");
        }

        const data = await response.json();
        console.log("address ", data);  // Do something with the data here

        // Return the data (or transform it as needed)
        return data.data;

    } catch (err) {
        if (err.message === "Unauthorized") {
            alert("Your login session is invalid, please login again");
            logoutuser();  // Handle logout if the session is invalid
        } else {
            console.error("Error fetching address suggestions:", err);
        }

        // Return null or an empty array in case of an error
        return null;
    }
};

export const addressDetailByViewPort = async (body) => {
    try {
        const response = await API.addressViewPort(body);

        if (checkAuthError(response)) {
            // If authorization error, throw an error
            throw new Error("Unauthorized");
        }

        const data = await response.json();
        console.log("address ", data);  // Do something with the data here

        // Return the data (or transform it as needed)
        return data.data;

    } catch (err) {
        if (err.message === "Unauthorized") {
            alert("Your login session is invalid, please login again");
            logoutuser();  // Handle logout if the session is invalid
        } else {
            console.error("Error fetching address suggestions:", err);
        }

        // Return null or an empty array in case of an error
        return null;
    }
};
